"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnicodeStringValueDestination = void 0;
var tslib_1 = require("tslib");
var string_1 = require("@devexpress/utils/lib/utils/string");
var destination_type_1 = require("../utils/destination-type");
var string_value_destination_base_1 = require("./string-value-destination-base");
var UnicodeStringValueDestination = (function (_super) {
    tslib_1.__extends(UnicodeStringValueDestination, _super);
    function UnicodeStringValueDestination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = [];
        return _this;
    }
    Object.defineProperty(UnicodeStringValueDestination.prototype, "destinationType", {
        get: function () { return destination_type_1.DestinationType.UnicodeStringValueDestination; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnicodeStringValueDestination.prototype, "value", {
        get: function () { return string_1.StringUtils.trimEnd(this._value.join(""), [';']); },
        enumerable: false,
        configurable: true
    });
    UnicodeStringValueDestination.prototype.processCharCore = function (ch) {
        if (ch != UnicodeStringValueDestination.emptyChar)
            this._value.push(ch);
        else
            this._value.push(UnicodeStringValueDestination.lowbar);
    };
    UnicodeStringValueDestination.prototype.createClone = function () {
        var clone = this.createEmptyClone();
        clone._value = this._value;
        return clone;
    };
    UnicodeStringValueDestination.emptyChar = '\0';
    UnicodeStringValueDestination.lowbar = '_';
    return UnicodeStringValueDestination;
}(string_value_destination_base_1.StringValueDestinationBase));
exports.UnicodeStringValueDestination = UnicodeStringValueDestination;
